<div class="p-6 tax-category-container flex-table-page" data-testid="tax-category-page">
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">
      {{ "settings.product.tax_categories.title" | translate }}
    </h2>
  </div>

  <app-search-form
    data-testid="tax-category-search-form"
    [searchFormat]="searchFormConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'tax-category-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      @if (canCreate()) {
        <app-button
          [testId]="'tax-category-add-btn'"
          [label]="'common.actions.new' | translate"
          type="info"
          (emitOnClick)="onAdd()"
        ></app-button>
      }
    </div>
  </app-search-form>

  <div class="flex-table-section">
    <advanced-data-table
      #advancedTable
      data-testid="tax-category-table"
      [dataSource]="taxCategories()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [rows]="rows"
      [first]="page() * rows"
      [totalRecords]="totalRecords()"
      [loading]="loading()"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
      <ng-template #customTemplate let-value let-column="column" let-rowData="rowData">
        @if (column && column.prop === "taxRate") {
          <span>{{ formatRate(value) }}</span>
        } @else if (column && column.prop === "activeFlag") {
          <div class="flex items-center justify-center">
            <p-tag
              [attr.data-testid]="'tax-category-status-tag-' + rowData.id"
              [value]="getStatusLabel(rowData.activeFlag)"
              [severity]="getStatusSeverity(rowData.activeFlag)"
              styleClass="status-tag"
              size="small"
            ></p-tag>
          </div>
        } @else if (
          column &&
          (column.prop === "effectiveFrom" || column.prop === "effectiveTo")
        ) {
          <span class="text-xs text-gray-600">{{
            formatDate(value, column.prop === "effectiveTo")
          }}</span>
        }
      </ng-template>

      <ng-template #actionsTemplate let-rowData>
        <div class="flex gap-2 justify-center">
          @if (canRead()) {
            <button
              type="button"
              [attr.data-testid]="'tax-category-view-btn-' + rowData.id"
              class="action-link action-view"
              (click)="onView(rowData)"
            >
              {{ "common.actions.view" | translate }}
            </button>
          }
          @if (canUpdate()) {
            <button
              type="button"
              [attr.data-testid]="'tax-category-edit-btn-' + rowData.id"
              class="action-link action-edit"
              (click)="onEdit(rowData)"
            >
              {{ "common.actions.edit" | translate }}
            </button>
            <button
              type="button"
              [attr.data-testid]="'tax-category-toggle-btn-' + rowData.id"
              class="action-link"
              [class.action-disable]="rowData.activeFlag"
              [class.action-enable]="!rowData.activeFlag"
              (click)="onToggleActive(rowData)"
            >
              {{
                (rowData.activeFlag
                  ? "settings.product.tax_categories.actions.deactivate"
                  : "settings.product.tax_categories.actions.activate"
                ) | translate
              }}
            </button>
          }
        </div>
      </ng-template>
    </advanced-data-table>
  </div>
</div>

<p-toast data-testid="tax-category-toast"></p-toast>

<app-confirmation-dialog
  data-testid="tax-category-confirmation-dialog"
  [(visible)]="showConfirmationDialog"
  [title]="confirmationTitle()"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
></app-confirmation-dialog>
